import { defineSlotRecipe } from '@chakra-ui/react';

export const emptyState = defineSlotRecipe({
  // eslint-disable-next-line i18next/no-literal-string -- styles not user facing
  slots: ['root', 'content', 'indicator', 'title', 'description'],
  className: 'chakra-empty-state',
  base: {
    title: {
      fontWeight: 'bold',
    },
  },

  variants: {
    status: {
      info: {
        indicator: {
          color: 'fg.info',
        },
      },
      neutral: {
        indicator: {
          color: 'fg.info',
        },
      },
      success: {
        indicator: {
          color: 'fg.success',
        },
      },
      error: {
        indicator: {
          color: 'fg.error',
        },
      },
      warning: {
        indicator: {
          color: 'fg.warning',
        },
      },
    },
    size: {
      sm: {
        root: {
          px: '2',
          py: '3',
        },
        title: {
          textStyle: 'lg',
          fontWeight: 'bold',
          lineHeight: 1.33,
        },
        content: {
          gap: '0',
        },
        description: {
          textStyle: 'md',
          lineHeight: 1.5,
        },
      },
      md: {
        root: {
          px: '4',
          py: '6',
        },
        title: {
          textStyle: '2xl',
          fontWeight: 'bold',
          lineHeight: 1.33,
        },
        content: {
          gap: '0',
          fontSize: 'md',
        },
        indicator: {
          textStyle: '4xl',
        },
        description: {
          textStyle: 'md',
          lineHeight: 1.5,
        },
      },
      lg: {
        root: {
          px: '6',
          py: '10',
        },
        title: {
          textStyle: '4xl',
          fontWeight: 'bold',
          lineHeight: 1.33,
        },
        content: {
          gap: '0',
        },
        indicator: {
          textStyle: '6xl',
        },
        description: {
          textStyle: 'lg',
          lineHeight: 1.5,
        },
      },
    },
  },

  defaultVariants: {
    size: 'lg',
  },
});
